"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsSelectedDatasetHidden = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var safeSerializeObjRef_1 = require("../../../../_staging/metadata/safeSerializeObjRef");
function useIsSelectedDatasetHidden(selectedDateDatasetRef) {
    var _this = this;
    var _a, _b;
    var backend = sdk_ui_1.useBackendStrict();
    var workspace = sdk_ui_1.useWorkspaceStrict();
    var allDateDatasets = model_1.useDashboardSelector(model_1.selectCatalogDateDatasets);
    var objectAvailability = model_1.useDashboardSelector(model_1.selectObjectAvailabilityConfig);
    var hasObjectAvailability = !!(((_a = objectAvailability.excludeObjectsWithTags) === null || _a === void 0 ? void 0 : _a.length) || ((_b = objectAvailability.includeObjectsWithTags) === null || _b === void 0 ? void 0 : _b.length));
    var _c = sdk_ui_1.useCancelablePromise({
        promise: hasObjectAvailability
            ? function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var catalog;
                var _a, _b;
                return tslib_1.__generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, backend
                                .workspace(workspace)
                                .catalog()
                                .withGroups(false)
                                .forTypes(["dateDataset"])
                                .excludeTags(((_a = objectAvailability.excludeObjectsWithTags) !== null && _a !== void 0 ? _a : []).map(function (tag) { return sdk_model_1.idRef(tag); }))
                                .includeTags(((_b = objectAvailability.includeObjectsWithTags) !== null && _b !== void 0 ? _b : []).map(function (tag) { return sdk_model_1.idRef(tag); }))
                                .load()];
                        case 1:
                            catalog = _c.sent();
                            return [2 /*return*/, catalog.dateDatasets()];
                    }
                });
            }); }
            : function () { return Promise.resolve(allDateDatasets); },
    }, [backend, workspace, objectAvailability]), visibleDateDatasets = _c.result, status = _c.status;
    var selectedDateDatasetHiddenByObjectAvailability = react_1.useMemo(function () {
        if (!visibleDateDatasets || !selectedDateDatasetRef) {
            return false;
        }
        return !visibleDateDatasets.some(function (ds) { return sdk_model_1.areObjRefsEqual(selectedDateDatasetRef, ds.dataSet.ref); });
    }, [safeSerializeObjRef_1.safeSerializeObjRef(selectedDateDatasetRef), visibleDateDatasets]);
    return {
        selectedDateDatasetHiddenByObjectAvailability: selectedDateDatasetHiddenByObjectAvailability,
        status: status,
    };
}
exports.useIsSelectedDatasetHidden = useIsSelectedDatasetHidden;
//# sourceMappingURL=useIsSelectedDatasetHidden.js.map